import React from "react";

const OrganizationManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51.332"
      height="51.357"
      viewBox="0 0 51.332 51.357"
    >
      <path
        id="db58"
        d="M176.256,170.916H183.1a4.283,4.283,0,0,1,4.277,4.278V178.8a13.647,13.647,0,0,1-15.4,0v-3.609a4.284,4.284,0,0,1,4.278-4.278ZM160,193.159a6,6,0,1,0,4.233,1.756A5.991,5.991,0,0,0,160,193.159Zm23.955-28.232a4.282,4.282,0,1,0-1.254,3.023A4.279,4.279,0,0,0,183.956,164.927Zm-13.688,10.266a5.994,5.994,0,0,1,5.278-5.942,5.989,5.989,0,1,1,8.265,0,5.995,5.995,0,0,1,5.279,5.942v2.215a13.689,13.689,0,1,0-18.822,0Zm29.088,17.966a6,6,0,1,0,4.233,1.756A5.991,5.991,0,0,0,199.356,193.159Zm-19.678,0a6,6,0,1,0,4.233,1.756,5.99,5.99,0,0,0-4.233-1.756ZM160.857,191.5v-2.617a.856.856,0,0,1,.856-.855h17.11V191.5a7.278,7.278,0,0,1,1.711,0v-3.473h17.11a.856.856,0,0,1,.855.855V191.5a7.278,7.278,0,0,1,1.711,0v-2.617a2.569,2.569,0,0,0-2.567-2.567h-17.11v-3.465c-.285.016-.567.043-.856.043s-.571-.028-.855-.043v3.465h-17.11a2.569,2.569,0,0,0-2.567,2.567V191.5a7.274,7.274,0,0,1,1.711,0Z"
        transform="translate(-154.013 -153.779)"
        fill={fill ? fill : "#43e57a"}
      />
    </svg>
  );
};

export default OrganizationManagementIcon;
